import { Collapse } from 'react-bootstrap';
import type { FC, PropsWithChildren } from 'react';

interface CollapsibleSubmenuProps {
  isOpen: boolean;
}

const CollapsibleSubmenu: FC<PropsWithChildren<CollapsibleSubmenuProps>> = ({ isOpen, children }) => {
  return (
    <Collapse in={isOpen}>
      <div className="collapsible-submenu">
        {children}
      </div>
    </Collapse>
  );
};

export default CollapsibleSubmenu;